import React from 'react';
import { ReflexContainer, ReflexElement, ReflexSplitter } from 'react-reflex';
import 'react-reflex/styles.css';

export class FlexibleContainer extends React.PureComponent {
  render() {
    return (
      <ReflexContainer orientation={this.props.orientation}>
        <ReflexElement className="left-pane">
          {this.props.children[0]}
        </ReflexElement>
        <ReflexSplitter />
        <ReflexElement className="right-pane">
          {this.props.children[1]}
        </ReflexElement>
      </ReflexContainer>
    );
  }
}
